<script>
   /*************************************************************/
   /* Svelte component for loading dataset from CSV file       */
   /*************************************************************/

   // Matrix and related methods
   import { Matrix } from 'mdatools/arrays';

   // control elements
   import { FileSelector, Select, Container, ButtonCancel, Button } from './controls';

   // calibration set
   export let dataset = null;

   let dataFile = null;             // CSV file
   let sep = ',';                   // seperator between values
   let firstColumn = 'values';      // what is in the first column of CSV file
   let firstRow = 'header';         // what is in the first row of CSV file

   // app status for handling and showing errors
   let status = 'neutral';
   let errMsg = '';

   // possible delimeters
   const sepOptions = [',', ';'];
   const firstRowOptions = ['header', 'values'];
   const firstColumnOptions = ['labels', 'values'];

   // gets CSV content as one large string, parse it into matrix
   function setData(strData) {
      try{
         dataset = Matrix.parseCSV(
            strData,
            sep,
            firstRow === "header",
            firstColumn === "labels"
         );

         if (dataset.values.nrows < 3 || dataset.values.ncols < 3) {
            throw new Error('Dataset must have at least 3 rows and 3 columns');
         }
         errMsg = ''
         status = 'success';
      } catch (e) {
         dataset = null;
         status = 'error';
         errMsg = e;
      }
   }

   // promise for reading the CSV file
   function readFile (e) {
      const reader = new FileReader();
      reader.onload = () => setData(reader.result);
      reader.readAsBinaryString(dataFile);
   }

   // reset whole component to initial state
   function reset () {
      dataset = null;
      dataFile = null;
   }

   // reactive expression for tracking changes of 'dataFile'
   $: if (dataFile === null) {
      // if data file is empty reset status and error messages
      reset();
   } else {
      // if not just remove error messages if any
      status = 'neutral';
      errMsg = '';
   }

   // reactive expression for tracking changes of 'sep'
   $: if (sep) {
      // if separator was changed remove error message
      status = 'neutral';
      errMsg = '';
   }

</script>

{#if dataset === null}

   <!-- show if data is not loaded -->
   <!-- reset component if dataFile is changed inside -->
   {#key dataFile === undefined}
   <Container>
      <FileSelector id="dataFile" bind:file={dataFile} />
   </Container>
   {/key}

   <!-- show if file is selected but data is not loaded -->
   {#if dataFile}
   <Container label="Delimiter:">
      <Select id="sep" bind:value={sep} options={sepOptions} />
   </Container>
   <Container label="First row:">
      <Select id="firstRow" bind:value={firstRow} options={firstRowOptions} />
   </Container>
   <Container label="First column:">
      <Select id="firstColumn" bind:value={firstColumn} options={firstColumnOptions} />
   </Container>
   <Container label="&nbsp;">
      <Button on:click={readFile}>Load</Button>
   </Container>
   {/if}

{:else}

   <!-- dataset is loaded - show info and cancel button -->
   <Container>
   <p>Dataset is loaded. X: {dataset.values.nrows}&times;{dataset.values.ncols - 1}, y: {dataset.values.nrows}&times;1</p>
      <ButtonCancel on:click={reset} />
   </Container>

{/if}

<!-- error message -->
{#if status === 'error' || errMsg}
<Container status="error">
   <p>{errMsg}</p>
</Container>
{/if}

